import React from 'react';
import { Scale, ArrowLeft } from 'lucide-react';

export const NotFound: React.FC<{ onHome: () => void }> = ({ onHome }) => (
 <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center px-6">
 <div className="text-center max-w-md">
 <Scale className="w-12 h-12 text-[#3730A3] mx-auto mb-6" />
 <h1 className="text-6xl font-bold text-[#1A1A1A] mb-2">404</h1>
 <p className="text-lg text-[#3F3D39] mb-8">
 The page you're looking for doesn't exist or has been moved.
 </p>
 <button
 onClick={onHome}
 className="inline-flex items-center gap-2 bg-[#3730A3] hover:bg-[#2E2780] text-white text-sm font-medium px-5 py-2.5 rounded-md transition-colors"
 >
 <ArrowLeft className="w-4 h-4" />
 Back to home
 </button>
 </div>
 </div>
);
